import ddIcon from '@disy/cadenza-icons/dd.svg';
import dddIcon from '@disy/cadenza-icons/ddd.svg';

import { Action } from 'cadenza/action';
import { workbookMapIframeApi } from 'cadenza/map/custom/workbook/workbook-map-post-message-api';
import { logger } from 'cadenza/utils/logging';
import { icon } from 'cadenza/utils/icon/icon';
import timeline3dToolbarI18n from 'cadenza/timeline-visualization-3d/timeline-3d-toolbar/timeline-3d-toolbar.properties';
import mapActionsI18n from 'cadenza/map/actions/map-actions.properties';
import { on } from 'cadenza/utils/event-util';
import { MessageTypes } from 'cadenza/utils/post-message/post-message-api';
import { WorkbookMapPostMessageTypes } from 'cadenza/workbook/view/view-content/workbook-post-message-types';

export const TIMELINE_MODE_2D = '2D';
export const TIMELINE_MODE_3D = '3D';

/**
 * Enables/disables 3D timeline visualization.
 */
export class Workbook3dTimelineAction extends Action {

  _viewId;
  _timelineMode;

  constructor (viewId, label, actionIcon, timelineMode) {
    super({ label, icon: actionIcon });
    this._timelineMode = timelineMode;
    this._viewId = viewId;
  }

  isSupportedSync () {
    return true;
  }

  executeSync () {
    const enabled3D = this._timelineMode === TIMELINE_MODE_3D;
    const refreshOptions = {
      sourceViewId: this._viewId,
      enabled3D
    };
    workbookMapIframeApi.sendTimeline3dEnabled(this._viewId, enabled3D)
      .then(result => workbookMapIframeApi.refreshToolbarButton3D(refreshOptions))
      .catch(error => logger.error(error));
  }

}

export class WorkbookSwitchTo3dTimelineAction extends Workbook3dTimelineAction {

  _supported = false;
  _hidden = false;

  constructor (viewId) {
    super(viewId, mapActionsI18n('timelineVisualization3d'), icon(dddIcon), TIMELINE_MODE_3D);
    this.updateState({
      mapHasTimelineData: workbookMapIframeApi.parentInitParams?.timelineData.mapHasTimelineData,
      toggle3dEnabled: false
    });
    on(workbookMapIframeApi, MessageTypes.RELOAD, event => this.updateState(event.detail));
    on(workbookMapIframeApi, WorkbookMapPostMessageTypes.REFRESH_TOOLBAR_3D_BUTTON, (event) => {
      const { sourceViewId, enabled3D } = event.detail.refreshOptions;
      if (viewId !== sourceViewId) {
        this.supported = !enabled3D;
      }
    });
  }

  /*
   * We need this method, because we have to wait until RELOAD event is registered in workbook-map-view.js
   * to enable "switch to 3D" button. Otherwise, clicking on 3D button before RELOAD is registered does nothing
   */
  initialize () {
    this.updateState(workbookMapIframeApi.parentInitParams?.timelineData);
  }

  updateState ({ mapHasTimelineData = false, toggle3dEnabled = false } = {}) {
    this.supported = toggle3dEnabled;
  }

  isSupportedSync () {
    return this._supported;
  }

  get supported () {
    return this._supported;
  }

  set supported (isSupported) {
    if (this._supported !== isSupported) {
      this._supported = isSupported;
      this.dispatchEvent('change:supported');
    }
  }

  get hidden () {
    return this._hidden;
  }

  set hidden (hidden) {
    if (this._hidden !== hidden) {
      this._hidden = hidden;
      this.dispatchEvent('change:hidden');
    }
  }

}

export class WorkbookSwitchTo2dTimelineAction extends Workbook3dTimelineAction {

  _supported = false;

  constructor (viewId) {
    super(viewId, timeline3dToolbarI18n('button.changeTo2D'), icon(ddIcon), TIMELINE_MODE_2D);
  }

  isSupportedSync () {
    return this._supported;
  }

  get supported () {
    return this._supported;
  }

  set supported (isSupported) {
    if (this._supported !== isSupported) {
      this._supported = isSupported;
      this.dispatchEvent('change:supported');
    }
  }

}
